'use client'

import { useEffect } from 'react'

import { SETTINGS_GENERAL } from '@/config/settings.general'
import {
    captureLandingUtm,
    getAttributionParams,
    isStoreUrl,
    withStoreAttribution,
} from '@/lib/storeAttribution'

/**
 * Сохраняет utm посадки и дописывает атрибуцию в любую ссылку на Google Play /
 * App Store / смартлинк AppMetrica в момент клика (покрывает все кнопки сайта,
 * включая будущие). Плюс общая цель Метрики store_click с источником.
 */
export default function StoreAttribution(): null {
    useEffect(() => {
        captureLandingUtm()

        const onClick = (event: MouseEvent): void => {
            const anchor = (event.target as Element | null)?.closest?.(
                'a[href]'
            )
            if (
                !(anchor instanceof HTMLAnchorElement) ||
                !isStoreUrl(anchor.href)
            ) {
                return
            }
            const params = getAttributionParams()
            anchor.href = withStoreAttribution(anchor.href, params)

            if (SETTINGS_GENERAL.IS_PRODUCTION && window.ym) {
                const host = new URL(anchor.href).hostname
                window.ym(
                    SETTINGS_GENERAL.YANDEX_METRIKA_ID,
                    'reachGoal',
                    'store_click',
                    {
                        store: host.includes('apple')
                            ? 'app_store'
                            : host.includes('google')
                              ? 'google_play'
                              : 'smartlink',
                        utm_source: params.utm_source ?? '(none)',
                        utm_campaign: params.utm_campaign ?? '(none)',
                    }
                )
            }
        }

        // capture: href меняем до того, как браузер начнёт переход
        document.addEventListener('click', onClick, true)
        return (): void => document.removeEventListener('click', onClick, true)
    }, [])

    return null
}
